<template>
  <b-form-group
    :invalid-feedback="firstErrorMessage"
    :state="isValid"
    :label="label"
  >
    <slot
      :attrs="{ state: isValid }"
      :listeners="{
        input: () => preferredValidator.$touch(),
        focus: () => preferredValidator.$touch(),
      }"
    />
    <b-form-text v-if="helptext"> {{ helptext }} </b-form-text>
    <b-form-text
      v-if="
        !('required' in preferredValidator) &&
          !('sameAsPassword' in preferredValidator)
      "
      >{{ $t('optional') }}
    </b-form-text>
  </b-form-group>
</template>
<script>
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor'

export default {
  name: 'FormElement',
  props: {
    helptext: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  extends: singleErrorExtractorMixin,
}
</script>
